module.exports = __webpack_public_path__ + "static/media/img_difficulty.2672870e.png";